import { Card } from "@mui/material";

import defaultStyles from "./styles";

export interface Props {
  styles?: any;
  [rest: string]: any;
}

export default function StyledCard({ children, styles = {}, ...rest }: Props) {
  return (
    <Card sx={[defaultStyles.card, styles]} {...rest}>
      {children}
    </Card>
  );
}
